module.exports = __webpack_public_path__ + "img/selected2-min.c8b8e2b5.png";